<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import LocalIcon from '@/atoms/LocalIcon.vue';
import RowItemContainer, { ClickableRowItemProps } from '@/organisms/RowItemContainer.vue';
import { flowStore } from '@/parcours/stores/flowStore';
import {
  BODY_PARTS_ORDER,
  getRiskInfo,
  tmsBodyPartsConfig,
} from '@/parcours/flows/tms/tmsBodyParts.config';

const router = useRouter();
const route = useRoute();

const bodyParts = computed(() =>
  BODY_PARTS_ORDER.map((key) => {
    const config = tmsBodyPartsConfig[key];
    const risk = flowStore.data?.[config.riskField];
    return { key, config, risk };
  }),
);

async function goToBodyPart(key: string) {
  await router.push({
    name: `flow-${route.meta.flowId}-bodyPart_${key}`,
    params: route.params,
  });
}

const rowItems = computed<ClickableRowItemProps[]>(() =>
  bodyParts.value.map(({ key, config, risk }) => ({
    id: key,
    title: config.label,
    descriptionProps: {
      text: getRiskInfo(risk).label,
      class: getRiskInfo(risk).class,
    },
    class: 'py-4',
    onClick: () => goToBodyPart(key),
  })),
);
</script>

<template>
  <div class="w-full text-primary">
    <RowItemContainer :row-items="rowItems" row-item-type="RowItem">
      <LocalIcon background="brand" class="fill-grey-600" name="chevron-right" size="36" />
    </RowItemContainer>
  </div>
</template>
